// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ul-class[data-v-d4bc5cf8]{padding-left:20px}", "",{"version":3,"sources":["webpack://./resources/js/Components/Tools/DirectAdmin/HistoryErrorsModal.vue"],"names":[],"mappings":"AACA,2BACI,iBAAA","sourcesContent":["\n.ul-class{\n    padding-left: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
